var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"banner-wrapper",style:({
			'background-color': _vm.page.banner.color,
			'color': _vm.page.banner.textColor
		})},[_c('div',{staticClass:"banner"},[_c('h1',[_vm._v(_vm._s(_vm.page[this.lang].title))])])]),_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":_vm.page.img}})])])}
var staticRenderFns = []

export { render, staticRenderFns }